/**
 * Stringify an object. Return an empty string if it's not possible.
 */
export const safeStringify = (value: any): string => {
  try {
    return JSON.stringify(value)
  } catch (error) {
    console.error('Error while stringifying:', error)
    return ''
  }
}
